import "date-fns";
import InputAdornment from "@mui/material/InputAdornment";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import TextField from "@mui/material/TextField";

import React, { useState } from "react";
import ReactTimePicker from "react-time-picker";
import "../styles/input.scss";
import "react-time-picker/dist/TimePicker.css";

import { Calendar } from "primereact/calendar";
import config from "../config/config";
import { BiCalendar } from "react-icons/bi";
import { IoMdTime } from "react-icons/io";

export default function LabelInput({
  label,
  id,
  placeholder,
  type,
  onChange,
  value,
  rowMode,
  inputClass,
  disabled,
  readOnly,
  datalist,
  rightComponent,
  name,
  autoFocus,
  numberFormat: num,
  datePicker,
  onClick,
  noLabel,
  defaultValue,
  style = { width: 240 },
  leftIcon,
  containerStyle,
  required,
  multiline,
  timePicker,
  onFocus,
  onBlur,
  forceLabel,
  minTime,
  error,
  minDate,
  maxDate,
  ...rest
}) {
  const [dpOpen, setDpOpen] = useState(false);
  const openDatePicker = () => {
    setDpOpen(!dpOpen);
  };

  return (
    <div
      className="form-group"
      style={
        rowMode && {
          display: "flex",
          justifyContent: "space-between",
        }
      }
    >
      {!noLabel && forceLabel && (
        <label
          htmlFor={id}
          style={
            rowMode && {
              marginRight: 10,
              fontWeight: "600",
              flexGrow: 1,
              marginTop: 10,
            }
          }
        >
          {forceLabel}
        </label>
      )}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          position: "relative",
          ...containerStyle,
        }}
      >
        {datePicker && (
          <div
            className="d-flex"
            style={{ position: "relative", alignItems: "flex-end" }}
          >
            <div
              style={{
                position: "absolute",
                left: 10,
                bottom: 5,
                zIndex: 10,
              }}
            >
              <BiCalendar size={config.iconSize} color="silver" />
            </div>

            <Calendar
              // style={{ width: 300 }}
              autoComplete="off"
              defaultValue={defaultValue}
              id={id}
              maxDate={maxDate}
              type={type}
              disabled={disabled}
              minDate={minDate}
              readOnly={readOnly}
              inputClassName={`form-control ${inputClass} datepicker`}
              inputStyle={{
                maxWidth: 240,
                resize: "none",
                textIndent: 35,
                ...style,
              }}
              name={name || id}
              onChange={({ value }) => {
                onChange &&
                  onChange({
                    currentTarget: {
                      name,
                      value,
                    },
                  });
              }}
              onKeyUp={onChange}
              placeholder={placeholder}
              value={value}
              autoFocus={autoFocus}
              required={required}
              dateFormat="dd/mm/yy"
              // autoComplete={datalist && "off"}
              onClick={onClick}
              {...rest}
            ></Calendar>
          </div>
        )}
        {timePicker && (
          <div className="d-flex" style={{ position: "relative" }}>
            {
              <div style={{ position: "absolute", left: 10, zIndex: 1 }}>
                <IoMdTime size={config.iconSize} />
              </div>
            }

            <div className="plc">{placeholder}</div>
            <ReactTimePicker
              className={`form-control timepicker ${inputClass}`}
              id={id}
              value={value}
              placeholder={placeholder}
              autoFocus={autoFocus}
              required={required}
              disabled={disabled}
              readOnly={readOnly}
              name={name || id}
              disableClock={true}
              clearIcon={null}
              format="HH:mm"
              onFocus={(e) => {
                timePicker ? setDpOpen(true) : onFocus && onFocus(e);
              }}
              onBlur={(e) => {
                timePicker ? setDpOpen(false) : onBlur && onBlur(e);
              }}
              onChange={(val) => {
                if (!val) {
                  onChange && onChange({ currentTarget: { name, value: "" } });
                  return;
                }

                // enforce minTime  manually
                const parse = (t) => {
                  const [h, m] = t.split(":").map(Number);
                  const d = new Date();
                  d.setHours(h, m, 0, 0);
                  return d;
                };

                const selected = parse(val);
                let finalVal = val;

                if (minTime && selected < parse(minTime)) {
                  finalVal = minTime;
                }

                onChange &&
                  onChange({ currentTarget: { name, value: finalVal } });
              }}
              onClick={() => {
                onClick && onClick();
                datePicker && openDatePicker();
              }}
              {...rest}
            />
          </div>
        )}

        {!timePicker && !datePicker && !multiline && (
          <TextField
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <div>{leftIcon}</div>
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <div>{rightComponent}</div>
                </InputAdornment>
              ),
            }}
            autoComplete="off"
            defaultValue={defaultValue}
            id={id}
            type={type || "text"}
            onFocus={(e) => {
              timePicker ? setDpOpen(true) : onFocus && onFocus(e);
            }}
            onBlur={(e) => {
              timePicker ? setDpOpen(false) : onFocus && onBlur(e);
            }}
            disabled={disabled}
            readOnly={readOnly}
            className={`form-control ${inputClass}`}
            style={{ maxWidth: 240, ...style, border: "none" }}
            name={name || id}
            onChange={onChange}
            // onKeyUp={onChange}
            placeholder={placeholder}
            value={value}
            list={datalist && `d${id}`}
            autoFocus={autoFocus}
            required={required}
            label={label}
            error={error}
            helperText={error}
            // autoComplete={datalist && "off"}
            onClick={() => {
              onClick && onClick();
              datePicker && openDatePicker();
            }}
            {...rest}
          />
        )}
        {!timePicker && !datePicker && multiline && (
          <TextareaAutosize
            autoComplete="off"
            defaultValue={defaultValue}
            id={id}
            type={type}
            disabled={disabled}
            readOnly={readOnly}
            className={`form-control ${inputClass}`}
            style={{
              maxWidth: 240,
              resize: "none",
              textIndent: leftIcon ? 30 : 0,
              ...style,
            }}
            name={name || id}
            onChange={onChange}
            onKeyUp={onChange}
            placeholder={placeholder}
            value={value}
            list={datalist && `d${id}`}
            autoFocus={autoFocus}
            required={required}
            // autoComplete={datalist && "off"}
            onClick={() => {
              onClick && onClick();
              datePicker && openDatePicker();
            }}
            {...rest}
          />
        )}
        {/* {rightComponent && (
          <div style={{ marginLeft: 10 }}>{rightComponent}</div>
        )} */}
      </div>
      {datalist && (
        <datalist key={`x${id}`} id={`d${id}`}>
          {datalist.map((dataValue, n) => (
            <option key={`x${id}-${n}`} value={dataValue} />
          ))}
        </datalist>
      )}
    </div>
  );
}
